import React from 'react';

const Privacy = () => {
    return (
        <section className="py-8 bg-black text-white font-pomelo">
            <div className="container mx-auto px-4">
                <h1 className="text-4xl font-bold mb-6">Políticas de Privacidad de Stupid Comedy</h1>

                <h3 className="text-2xl font-semibold mt-8">1. Introducción</h3>
                <p className="mb-4">
                    Bienvenido a Stupid Comedy. En Stupid Comedy, valoramos y respetamos su privacidad. Esta Política de Privacidad describe cómo recopilamos, utilizamos, divulgamos y protegemos su información personal cuando utiliza nuestra plataforma de streaming.
                </p>

                <h3 className="text-2xl font-semibold mt-8">2. Información que Recopilamos</h3>

                <p className="text-xl font-semibold mt-4">a. Información que Usted Nos Proporciona</p>
                <ul className="list-disc ml-8 mb-4">
                    <li className="mb-2"><strong>Registro y Cuenta:</strong> Cuando se registra en Stupid Comedy, recopilamos información como su nombre, dirección de correo electrónico, número de teléfono y detalles de pago.</li>
                    <li className="mb-2"><strong>Contenido Generado por el Usuario:</strong> Cualquier contenido que usted suba, publique o comparta en nuestra plataforma, como comentarios, reseñas y comunicaciones con nuestro equipo de soporte.</li>
                </ul>

                <p className="text-xl font-semibold mt-4">b. Información Recopilada Automáticamente</p>
                <ul className="list-disc ml-8 mb-4">
                    <li className="mb-2"><strong>Datos de Uso:</strong> Recopilamos información sobre su interacción con nuestra plataforma, incluyendo el contenido que ve, la duración de sus sesiones y sus preferencias de visualización.</li>
                    <li className="mb-2"><strong>Datos del Dispositivo:</strong> Información sobre los dispositivos que utiliza para acceder a nuestra plataforma, incluyendo el tipo de dispositivo, sistema operativo, identificadores únicos del dispositivo y datos de red móvil.</li>
                </ul>

                <p className="text-xl font-semibold mt-4">c. Información de Terceros</p>
                <ul className="list-disc ml-8 mb-4">
                    <li className="mb-2"><strong>Integraciones de Redes Sociales:</strong> Si decide conectar su cuenta de Stupid Comedy con redes sociales u otras plataformas de terceros, podemos recibir información de estos servicios.</li>
                    <li className="mb-2"><strong>Proveedores de Servicios:</strong> Podemos recibir información de nuestros proveedores de servicios, como datos de pago y verificación de identidad.</li>
                </ul>

                <h3 className="text-2xl font-semibold mt-8">3. Uso de la Información</h3>
                <p className="mb-4">Utilizamos su información personal para:</p>
                <ul className="list-disc ml-8 mb-4">
                    <li className="mb-2"><strong>Proveer el Servicio:</strong> Para proporcionarle acceso a nuestra plataforma de streaming y personalizar su experiencia.</li>
                    <li className="mb-2"><strong>Mejorar Nuestro Servicio:</strong> Analizar y mejorar la funcionalidad de nuestra plataforma y desarrollar nuevas características.</li>
                    <li className="mb-2"><strong>Comunicación:</strong> Enviarle notificaciones sobre su cuenta, respuestas a sus consultas, actualizaciones y promociones.</li>
                    <li className="mb-2"><strong>Seguridad:</strong> Detectar y prevenir fraudes, abusos y actividades ilegales.</li>
                    <li className="mb-2"><strong>Cumplimiento Legal:</strong> Cumplir con obligaciones legales y regulatorias.</li>
                </ul>

                <h3 className="text-2xl font-semibold mt-8">4. Compartir Información</h3>
                <p className="mb-4">Podemos compartir su información con:</p>
                <ul className="list-disc ml-8 mb-4">
                    <li className="mb-2"><strong>Proveedores de Servicios:</strong> Terceros que nos ayudan a operar nuestra plataforma, procesar pagos y proporcionar soporte al cliente.</li>
                    <li className="mb-2"><strong>Socios Comerciales:</strong> Empresas con las que colaboramos para ofrecer contenido y promociones.</li>
                    <li className="mb-2"><strong>Autoridades Legales:</strong> En respuesta a solicitudes legales, órdenes judiciales o en cumplimiento de leyes aplicables.</li>
                    <li className="mb-2"><strong>Transacciones Comerciales:</strong> En el contexto de fusiones, adquisiciones o ventas de activos, su información puede ser transferida como parte de la transacción.</li>
                </ul>

                <h3 className="text-2xl font-semibold mt-8">5. Seguridad de la Información</h3>
                <p className="mb-4">
                    Implementamos medidas de seguridad razonables para proteger su información personal contra acceso no autorizado, alteración, divulgación o destrucción. Sin embargo, ningún método de transmisión o almacenamiento es completamente seguro, por lo que no podemos garantizar la seguridad absoluta.
                </p>

                <h3 className="text-2xl font-semibold mt-8">6. Sus Derechos</h3>
                <p className="mb-4">Usted tiene derecho a:</p>
                <ul className="list-disc ml-8 mb-4">
                    <li className="mb-2"><strong>Acceder y Corregir:</strong> Solicitar acceso a la información personal que tenemos sobre usted y corregir cualquier error.</li>
                    <li className="mb-2"><strong>Eliminar:</strong> Solicitar la eliminación de su información personal.</li>
                    <li className="mb-2"><strong>Oposición:</strong> Oponerse al procesamiento de su información personal en ciertas circunstancias.</li>
                    <li className="mb-2"><strong>Portabilidad:</strong> Solicitar la transferencia de su información personal a otra entidad.</li>
                </ul>
                <p className="mb-4">
                    Para ejercer estos derechos, puede contactarnos a través de la información de contacto proporcionada a continuación.
                </p>

                <h3 className="text-2xl font-semibold mt-8">7. Retención de Datos</h3>
                <p className="mb-4">
                    Retendremos su información personal durante el tiempo que sea necesario para cumplir con los propósitos descritos en esta Política de Privacidad, a menos que la ley requiera o permita un período de retención más largo.
                </p>

                <h3 className="text-2xl font-semibold mt-8">8. Cambios en esta Política de Privacidad</h3>
                <p className="mb-4">
                    Podemos actualizar esta Política de Privacidad de vez en cuando. Le notificaremos sobre cualquier cambio mediante la publicación de la nueva política en nuestra plataforma y actualizando la fecha de "Última actualización".
                </p>

                <h3 className="text-2xl font-semibold mt-8">9. Contacto</h3>
                <p className="mb-4">
                    Si tiene alguna pregunta o inquietud sobre esta Política de Privacidad o nuestras prácticas de privacidad, puede contactarnos en:
                </p>
                <p className="mb-4">
                    Stupid Comedy <br />
                    Correo electrónico: contacto@austranet.com
                </p>

                <h3 className="text-2xl font-semibold mt-8">10. Aceptación de la Política de Privacidad</h3>
                <p className="mb-4">
                    Al utilizar nuestra plataforma, usted acepta los términos de esta Política de Privacidad. Si no está de acuerdo con esta política, por favor no utilice nuestra plataforma.
                </p>

                <p className="mt-8">Última actualización: 28 de Junio de 2024.</p>
            </div>
        </section>
    );
};

export default Privacy;
